module.exports = __webpack_public_path__ + "media/images/zoomify_full-ae823a17f79b65ee92170b5941aed915.png";